export default __webpack_public_path__ + "static/hero_2-eb5336431866bc9dd23adbd3c0058c29.jpg";